const wrist_questions = [
   {
      "question":"How is ##name## being evaluated today?",
      "sub":"",
      "type":"radio",
      "telehealth":"form1[0].#subform[0].Public2507Questions[0].HowExamCOnducted[0]",
      "show": true,
      "section": {
         page: "1",
         title: "Disability Benefits Questionnaire",
         number: "0"
      },
      "questions":[
         {
            "label":"How was the examination conducted?",
            "title":"",
            "subMain":"",
            "sub":"",
            "radioGroup":"form1[0].#subform[0].Public2507Questions[0].RadioButtonList[2]",
            "options":[
               {
                  "main":"In-Person Exam",
                  "dbqName":"1",
                  "sub":""
               },
               {
                  "main":"Video Telehealth",
                  "dbqName":"2",
                  "sub":""
               }
            ],
            "answer":"In-Person Exam"
         }
      ]
   },
   {
      "question":"Is ##name## regularly seen as a patient in your clinic?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "1",
         title: "Disability Benefits Questionnaire",
         number: "0"
      },
      "presidence":"Yes",
      "radioGroup":"form1[0].#subform[0].Public2507Questions[0].RadioButtonList[1]",
      "ref":0,
      "dbqName_yes":"1",
      "dbqName_no":"2",
      "answer":"",
   },
   {
      "question":"Did you review any of the patients records for this condition?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "1",
         title: "Disability Benefits Questionnaire",
         number: "0"
      },
      "presidence":"Yes",
      "radioGroup":"form1[0].#subform[0].PublicEvidenceReview[0].RadioButtonList[0]",
      "ref":0,
      "dbqName_yes":"2",
      "dbqName_no":"1",
      "answer":"",
      "istext": true,
      "textarea": false,
      "placeholder": "Please identify the evidence reviewed and the date range",
      "textdbqName":"form1[0].#subform[0].PublicEvidenceReview[0].IdentifyEvidence[0]",
      "textanswer":""
   },
   {
      "question":"Initial ROM Measurements for ##redHeading##",
      "redHeading": "Right Wrist",
      "sub":"",
      "type":"text",
      "show": true,
      "section": {
         page: "4",
         title: "ROM AND FUNCTIONAL LIMITATION",
         number: "3A"
      },
      "questions":[
         {
            "main":"Dorsiflexion",
            "subMain":"Normal Endpoint is 70 Degrees",
            "sub":"Post-Test ROM Measurement",
            "type":"select",
            "dbqName":"form1[0].#subform[6].TextField6[82]",
            "defaultVal":"70",
            "values":["70", "65", "60", "55", "50", "45", "40", "35", "30", "25", "20", "15", "10", "5"],
            "answer":"70"
         },
         {
            "main":"Palmar Flexion",
            "subMain":"Normal Endpoint is 80 Degrees",
            "sub":"Post-Test ROM Measurement",
            "type":"select",
            "dbqName":"form1[0].#subform[6].TextField6[83]",
            "defaultVal":"80",
            "values":["80","75","70", "65", "60", "55", "50", "45", "40", "35", "30", "25", "20", "15", "10", "5"],
            "answer":"80"
         },         
         {
            "main":"Ulnar Deviation",
            "subMain":"Normal Endpoint is 45 Degrees",
            "sub":"Post-Test ROM Measurement",
            "type":"select",
            "dbqName":"form1[0].#subform[6].TextField6[84]",
            "defaultVal":"45",
            "values":["45", "40", "35", "30", "25", "20", "15", "10", "5"],
            "answer":"45"
         },
         {
            "main":"Radial Deviation",
            "subMain":"Normal Endpoint is 20 Degrees",
            "sub":"Post-Test ROM Measurement",
            "type":"select",
            "dbqName":"form1[0].#subform[6].TextField6[85]",
            "defaultVal":"20",
            "values":["20", "15", "10", "5"],
            "answer":"20"
         }
      ]
   },
   {
      "question":"Which ROM exhibited pain for ##redHeading##? ",
      "redHeading":"Right Wrist",
      "sub":"Check all that apply",
      "type":"radioTiles",
      "multi": true,
      "show": true,
      "small": true,
      "partial": true,
      "cols": 2,
      "section": {
         page: "4",
         title: "ROM AND FUNCTIONAL LIMITATION",
         number: "3A"
      },
      "questions":[
         {
            "main":"Dorsiflexion",
            "dbqName":"form1[0].#subform[6].CheckBox37[16]",
            "answer":""
         },
         {
            "main":"Ulnar deviation",
            "dbqName":"form1[0].#subform[6].CheckBox37[18]",
            "answer":""
         },
         {
            "main":"Palmar flexion",
            "dbqName":"form1[0].#subform[6].CheckBox37[17]",
            "answer":""
         },
         {
            "main":"Radial deviation",
            "dbqName":"form1[0].#subform[6].CheckBox37[19]",
            "answer":""
         },
         {
            "main":"None",
            "dbqName":"pass_this_question",
            "partialField": true,
            "answer":""
         }            
      ],
      "answer":""
   },
   {
      "question":"Initial ROM Measurements for ##redHeading##",
      "redHeading": "Left Wrist",
      "sub":"",
      "type":"text",
      "show": true,
      "section": {
         page: "4",
         title: "ROM AND FUNCTIONAL LIMITATION",
         number: "3A"
      },
      "questions":[         
         {
            "main":"Dorsiflexion",
            "subMain":"Normal Endpoint is 70 Degrees",
            "sub":"Post-Test ROM Measurement",
            "type":"select",
            "dbqName":"form1[0].#subform[6].TextField6[90]",
            "defaultVal":"70",
            "values":["70", "65", "60", "55", "50", "45", "40", "35", "30", "25", "20", "15", "10", "5"],
            "answer":"70"
         },
         {
            "main":"Palmar Flexion",
            "subMain":"Normal Endpoint is 80 Degrees",
            "sub":"Post-Test ROM Measurement",
            "type":"select",
            "dbqName":"form1[0].#subform[6].TextField6[91]",
            "defaultVal":"80",
            "values":["80","75","70", "65", "60", "55", "50", "45", "40", "35", "30", "25", "20", "15", "10", "5"],
            "answer":"80"
         },
         {
            "main":"Ulnar Deviation",
            "subMain":"Normal Endpoint is 45 Degrees",
            "sub":"Post-Test ROM Measurement",
            "type":"select",
            "dbqName":"form1[0].#subform[6].TextField6[92]",
            "defaultVal":"45",
            "values":["45", "40", "35", "30", "25", "20", "15", "10", "5"],
            "answer":"45"
         },
         {
            "main":"Radial Deviation",
            "subMain":"Normal Endpoint is 20 Degrees",
            "sub":"Post-Test ROM Measurement",
            "type":"select",
            "dbqName":"form1[0].#subform[6].TextField6[93]",
            "defaultVal":"20",
            "values":["20", "15", "10", "5"],
            "answer":"20"
         }
      ]
   },
   {
      "question":"Which ROM exhibited pain for ##redHeading##? ",
      "redHeading":"Left Wrist",
      "sub":"Check all that apply",
      "type":"radioTiles",
      "multi": true,
      "show": true,
      "small": true,
      "partial": true,
      "cols": 2,
      "section": {
         page: "4",
         title: "ROM AND FUNCTIONAL LIMITATION",
         number: "3A"
      },
      "questions":[
         {
            "main":"Dorsiflexion",
            "dbqName":"form1[0].#subform[6].CheckBox37[39]",
            "answer":""
         },
         {
            "main":"Ulnar deviation",
            "dbqName":"form1[0].#subform[6].CheckBox37[41]",
            "answer":""
         },
         {
            "main":"Palmar flexion",
            "dbqName":"form1[0].#subform[6].CheckBox37[40]",
            "answer":""
         },
         {
            "main":"Radial deviation",
            "dbqName":"form1[0].#subform[6].CheckBox37[42]",
            "answer":""
         },
         {
            "main":"None",
            "dbqName":"pass_this_question",
            "partialField": true,
            "answer":""
         }              
      ],
      "answer":""
   },
   {
      "question":"Is there evidence of pain for ##redHeading##?",
      "redHeading":"Right Wrist",
      "sub":"",
      "type":"radioTiles",
      "multi": true,
      "partial": true,
      "show": true,
      "small": true,
      "cols": 2,
      "section": {
         page: "4",
         title: "ROM AND FUNCTIONAL LIMITATION",
         number: "3A"
      },
      "questions":[
         {
            "main":"Weight-bearing",
            "dbqName":"form1[0].#subform[6].CheckBox37[30],form1[0].#subform[6].#area[33].CheckBox37[37]",
            "answer":""
         },
         {
            "main":"Non-weight bearing",
            "dbqName":"form1[0].#subform[6].CheckBox37[31],form1[0].#subform[6].#area[33].CheckBox37[37]",
            "answer":""
         },
         {
            "main":"Active motion",
            "dbqName":"form1[0].#subform[6].CheckBox37[33],form1[0].#subform[6].#area[33].CheckBox37[37]",
            "answer":""
         },
         {
            "main":"Passive motion",
            "dbqName":"form1[0].#subform[6].CheckBox37[32],form1[0].#subform[6].#area[33].CheckBox37[37]",
            "answer":""
         },
         {
            "main":"On Rest/Non-movement",
            "dbqName":"form1[0].#subform[6].CheckBox37[34],form1[0].#subform[6].#area[33].CheckBox37[37]",
            "answer":""
         },
         {
            "main":"Causes functional loss",
            "dbqName":"form1[0].#subform[6].CheckBox37[35],form1[0].#subform[6].#area[33].CheckBox37[37]",
            "answer":"",
            "textarea": true,
            "textdbqName" : "form1[0].#subform[7].TextField6[121]",
            "placeholder": "describe in the functional loss",
            "textAnswer": ""
         },
         {
            "main":"Does not result in/cause functional loss",
            "dbqName":"form1[0].#subform[6].CheckBox37[36],form1[0].#subform[6].#area[33].CheckBox37[37]",
            "answer":""
         },
         {
            "main":"None",
            "partialField": true,
            "dbqName":"form1[0].#subform[6].#area[33].CheckBox37[38]",
            "answer":""
         }            
      ],
      "answer":""
   },
   {
      "question":"Is there evidence of pain for ##redHeading##?",
      "redHeading":"Left Wrist",
      "sub":"",
      "type":"radioTiles",
      "multi": true,
      "partial": true,
      "show": true,
      "small": true,
      "cols": 2,
      "section": {
         page: "4",
         title: "ROM AND FUNCTIONAL LIMITATION",
         number: "3A"
      },
      "questions":[
         {
            "main":"Weight-bearing",
            "dbqName":"form1[0].#subform[6].CheckBox37[53],form1[0].#subform[6].#area[34].CheckBox37[60]",
            "answer":""
         },
         {
            "main":"Non-weight bearing",
            "dbqName":"form1[0].#subform[6].CheckBox37[54],form1[0].#subform[6].#area[34].CheckBox37[60]",
            "answer":""
         },
         {
            "main":"Active motion",
            "dbqName":"form1[0].#subform[6].CheckBox37[56],form1[0].#subform[6].#area[34].CheckBox37[60]",
            "answer":""
         },
         {
            "main":"Passive motion",
            "dbqName":"form1[0].#subform[6].CheckBox37[55],form1[0].#subform[6].#area[34].CheckBox37[60]",
            "answer":""
         },
         {
            "main":"On Rest/Non-movement",
            "dbqName":"form1[0].#subform[6].CheckBox37[57],form1[0].#subform[6].#area[34].CheckBox37[60]",
            "answer":""
         },
         {
            "main":"Causes functional loss",
            "dbqName":"form1[0].#subform[6].CheckBox37[58],form1[0].#subform[6].#area[34].CheckBox37[60]",
            "answer":"",
            "textarea": true,
            "textdbqName" : "form1[0].#subform[7].TextField6[128]",
            "placeholder": "describe in the functional loss",
            "textAnswer": ""
         },
         {
            "main":"Does not result in/cause functional loss",
            "dbqName":"form1[0].#subform[6].CheckBox37[59],form1[0].#subform[6].#area[34].CheckBox37[60]",
            "answer":""
         },
         {
            "main":"None",
            "partialField": true,
            "dbqName":"form1[0].#subform[6].#area[34].CheckBox37[61]",
            "answer":""
         }            
      ],
      "answer":""
   },

   {
      "question":"Is there objective evidence of crepitus?",
      "sub":"",
      "type":"radio",
      "show": true,
      "section": {
         page: "5",
         title: "ROM AND FUNCTIONAL LIMITATION",
         number: "3A"
      },
      "questions":[
         {
            "label":"Right Wrist",
            "title":"",
            "subMain":"",
            "sub":"",
            "options":[
               {
                  "main":"Yes",
                  "dbqName":"form1[0].#subform[7].#area[37].CheckBox37[66]",
                  "sub":""
               },
               {
                  "main":"No",
                  "dbqName":"form1[0].#subform[7].#area[37].CheckBox37[67]",
                  "sub":""
               }
            ],
            "answer":"No"
         },
         {
            "label":"Left Wrist",
            "title":"",
            "subMain":"",
            "sub":"",
            "options":[
               {
                  "main":"Yes",
                  "dbqName":"form1[0].#subform[7].#area[41].CheckBox37[74]",
                  "sub":""
               },
               {
                  "main":"No",
                  "dbqName":"form1[0].#subform[7].#area[41].CheckBox37[75]",
                  "sub":""
               }
            ],
            "answer":"No"
         }
      ]
   },
   {
      "question":"Is there objective evidence of localized tenderness or pain on palpation of the joint or associated soft tissue for ##redHeading##?",
      "redHeading":"Right Wrist",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "5",
         title: "ROM AND FUNCTIONAL LIMITATION",
         number: "3A"
      },
      "presidence":"Yes",
      "ref":0,
      "dbqName_yes":"form1[0].#subform[7].#area[40].CheckBox37[72]",
      "dbqName_no":"form1[0].#subform[7].#area[40].CheckBox37[73]",
      "answer":"",
      "istext": true,
      "textarea": false,
      "placeholder": "Please explain. Include location, severity, and relationship to condition(s)",
      "textdbqName":"form1[0].#subform[7].TextField6[122]",
      "textanswer":""
   },   
   {
      "question":"Is there objective evidence of localized tenderness or pain on palpation of the joint or associated soft tissue for ##redHeading##?",
      "redHeading":"Left Wrist",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "5",
         title: "ROM AND FUNCTIONAL LIMITATION",
         number: "3A"
      },
      "presidence":"Yes",
      "ref":0,
      "dbqName_yes":"form1[0].#subform[7].#area[43].CheckBox37[78]",
      "dbqName_no":"form1[0].#subform[7].#area[43].CheckBox37[79]",
      "answer":"",
      "istext": true,
      "textarea": false,
      "placeholder": "Please explain. Include location, severity, and relationship to condition(s)",
      "textdbqName":"form1[0].#subform[7].TextField6[129]",
      "textanswer":""
   },

   {
      "question":"Indicate any surgical procedures that ##name## has had performed for ##redHeading## and provide the additional information as requested?",
      "redHeading":"Right wrist",
      "sub":"",
      "type":"radioModal",
      "multi": true,
      "partial": true,
      "show": true,
      "small": true,
      "cols": 2,
      "section": {
         page: "8",
         title: "SURGICAL PROCEDURES",
         number: "6A"
      },
      "questions":[
               {
                  "main":"No surgery",
                  "dbqName":"form1[0].#subform[10].CheckBox38[0]",
                  "partialField": true,
                  "answer":"",
               },   
               {
                  "main":"Total wrist joint replacement",
                  "dbqName":"form1[0].#subform[10].CheckBox37[162]",
                  "answer":"",
                  "multi": false,
                  "showSubItems": false,
                  "date1": "",
                  "dbqDate1": "form1[0].#subform[10].TextField6[179]",
                  "subItems": [
                     {
                        "main":"None",
                        "dbqName":"form1[0].#subform[10].CheckBox37[163]",
                        "colWidth": 3,
                        "answer":""
                     },
                     {
                        "main":"Intermediate degrees of residual weakness, pain, or limitation of motion",
                        "dbqName":"form1[0].#subform[10].CheckBox37[164]",
                        "colWidth": 9,
                        "answer":""
                     },
                     {
                        "main":"Other",
                        "dbqName":"form1[0].#subform[10].CheckBox37[165]",
                        "colWidth": 3,
                        "subItemLinked": true,
                        "answer":""
                     },
                     {
                        "main":"Chronic residuals consisting of severe painful motion or weakness",
                        "dbqName":"form1[0].#subform[10].CheckBox37[166]",
                        "colWidth": 9,
                        "answer":""
                     }
                     
                  ],
                  "subAnswer":"",
                  "subItemsLabel" :"Residuals",
                  "subItemOther": false,
                  "textOther": "",
                  "dbqNameOther": "form1[0].#subform[10].TextField6[180]",
                  "placeholderOther":"Other residuals describe",
               },
               {
                  "main":"Arthroscopic or other wrist surgery",
                  "dbqName":"form1[0].#subform[10].CheckBox37[167]",
                  "answer":"",
                  "multi": false,
                  "showSubItems": false,
                  "text1": "",
                  "dbqName1": "form1[0].#subform[10].TextField6[182]",
                  "placeholder1":"Type of surgery",
                  "date1": "",
                  "dbqDate1": "form1[0].#subform[10].TextField6[181]",
                  "text2": "",
                  "dbqName2": "form1[0].#subform[10].TextField6[183]",
                  "placeholder2":"Describe residuals",
                  
               },
                                    
            ],
            "answer":""
   },

   {
      "question":"Indicate any surgical procedures that ##name## has had performed for ##redHeading## and provide the additional information as requested?",
      "redHeading":"Left wrist",
      "sub":"",
      "type":"radioModal",
      "multi": true,
      "partial": true,
      "show": true,
      "small": true,
      "cols": 2,
      "section": {
         page: "8",
         title: "SURGICAL PROCEDURES",
         number: "6A"
      },
      "questions":[
               {
                  "main":"No surgery",
                  "dbqName":"form1[0].#subform[10].CheckBox38[1]",
                  "partialField": true,
                  "answer":"",
               },  
               {
                  "main":"Total wrist joint replacement",
                  "dbqName":"form1[0].#subform[10].CheckBox37[168]",
                  "answer":"",
                  "multi": false,
                  "showSubItems": false,
                  "date1": "",
                  "dbqDate1": "form1[0].#subform[10].TextField6[185]",
                  "subItems": [
                     {
                        "main":"None",
                        "dbqName":"form1[0].#subform[10].CheckBox37[169]",
                        "colWidth": 3,
                        "answer":""
                     },
                     {
                        "main":"Intermediate degrees of residual weakness, pain, or limitation of motion",
                        "dbqName":"form1[0].#subform[10].CheckBox37[170]",
                        "colWidth": 9,
                        "answer":""
                     },
                     {
                        "main":"Other",
                        "dbqName":"form1[0].#subform[10].CheckBox37[171]",
                        "colWidth": 3,
                        "subItemLinked": true,
                        "answer":""
                     },
                     {
                        "main":"Chronic residuals consisting of severe painful motion or weakness",
                        "dbqName":"form1[0].#subform[10].CheckBox37[172]",
                        "colWidth": 9,
                        "answer":""
                     }
                     
                  ],
                  "subAnswer":"",
                  "subItemsLabel" :"Residuals",
                  "subItemOther": false,
                  "textOther": "",
                  "dbqNameOther": "form1[0].#subform[10].TextField6[186]",
                  "placeholderOther":"Other residuals describe",
               },
               {
                  "main":"Arthroscopic or other wrist surgery",
                  "dbqName":"form1[0].#subform[10].CheckBox37[173]",
                  "answer":"",
                  "multi": false,
                  "showSubItems": false,
                  "text1": "",
                  "dbqName1": "form1[0].#subform[10].TextField6[188]",
                  "placeholder1":"Type of surgery",
                  "date1": "",
                  "dbqDate1": "form1[0].#subform[10].TextField6[187]",
                  "text2": "",
                  "dbqName2": "form1[0].#subform[10].TextField6[189]",
                  "placeholder2":"Describe residuals"
               },
                                     
            ],
            "answer":""
   },

   {
      "question":"Additional Comments",
      "sub":"",
      "optional": true,
      "type":"textarea",
      "show": true,
      "section": {
         page: "9",
         title: "REMARKS",
         number: "12A"
      },
      "options":[],
      "dbqName":"form1[0].#subform[11].TextField6[191]",
      "answer":""
   }
]

export default wrist_questions;